export function Spinner() {
  return (
    <div className="w-100 mt-20">
      <img
        width={180}
        src="https://i.gifer.com/ZKZg.gif"
        alt=""
        className="text-center mx-auto"
      />
    </div>
  );
}
